// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"52cebdfd","453":"b3e179eb"}[chunkId] + ".chunk.js";
};